/* =====================================================
   GullyLabs Thumbnail Strip — Flex Layout with Arrows
   
   Layout: [← arrow] [bordered image strip] [→ arrow]
   
   - Arrows sit OUTSIDE the bordered strip as flex items
   - ← → thin arrow characters replace Dawn's caret icons
   - No gaps between thumbnails, 1px dividers
   - Left arrow hidden at scroll start
   - Right arrow hidden at scroll end
   ===================================================== */

(function () {
    'use strict';

    function initThumbnailStrip() {
        // Only on mobile
        if (window.innerWidth >= 750) return;

        var gallery = document.querySelector('.gully-grid-gallery');
        if (!gallery) return;

        var thumbSlider = gallery.querySelector('.thumbnail-slider');
        if (!thumbSlider) return;

        var thumbList = thumbSlider.querySelector('.thumbnail-list');
        var prevBtn = thumbSlider.querySelector('.slider-button--prev');
        var nextBtn = thumbSlider.querySelector('.slider-button--next');

        if (!thumbList) return;

        /* ---- Style the container as flex row ---- */
        thumbSlider.style.cssText = [
            'display: flex',
            'flex-direction: row',
            'align-items: stretch',
            'margin-top: 0.8rem',
            'padding: 0',
            'position: relative',
            'border: none',
            'gap: 0'
        ].join(' !important; ') + ' !important;';

        /* ---- Style thumbnail list with top/bottom border ---- */
        thumbList.style.cssText = [
            'display: flex',
            'flex-wrap: nowrap',
            'flex: 1',
            'gap: 0',
            'padding: 0',
            'margin: 0',
            'overflow-x: auto',
            'scroll-snap-type: x mandatory',
            '-webkit-overflow-scrolling: touch',
            'scroll-behavior: smooth',
            'scrollbar-width: none',
            'list-style: none',
            'border-top: 1px solid #000000',
            'border-bottom: 1px solid #000000',
            'border-left: none',
            'border-right: none'
        ].join(' !important; ') + ' !important;';

        /* ---- Style each thumbnail item ---- */
        var items = thumbList.querySelectorAll('.thumbnail-list__item');
        items.forEach(function (item, index) {
            item.style.cssText = [
                'flex-shrink: 0',
                'margin: 0',
                'padding: 0',
                'scroll-snap-align: start'
            ].join(' !important; ') + ' !important;';
            if (index < items.length - 1) {
                item.style.borderRight = '1px solid #000000';
            }
        });

        /* ---- Style thumbnail buttons ---- */
        var thumbBtns = thumbList.querySelectorAll('.thumbnail');
        thumbBtns.forEach(function (btn) {
            btn.style.cssText = [
                'width: 80px',
                'height: 80px',
                'border: none',
                'border-radius: 0',
                'padding: 0',
                'margin: 0',
                'overflow: hidden',
                'display: flex',
                'align-items: center',
                'justify-content: center',
                'background: #FFFFFF'
            ].join(' !important; ') + ' !important;';
        });

        /* ---- Style arrow buttons as flex items ---- */
        function styleArrowBtn(btn) {
            if (!btn) return;
            btn.style.cssText = [
                'position: static',
                'flex-shrink: 0',
                'width: 30px',
                'height: auto',
                'display: flex',
                'align-items: center',
                'justify-content: center',
                'background: transparent',
                'background-color: transparent',
                'border: none',
                'border-radius: 0',
                'box-shadow: none',
                'padding: 0',
                'margin: 0',
                'cursor: pointer',
                'min-width: unset',
                'min-height: unset',
                'color: #000000',
                'transform: none'
            ].join(' !important; ') + ' !important;';

            // Hide Dawn's SVG icon
            var svgWrapper = btn.querySelector('.svg-wrapper');
            var icon = btn.querySelector('.icon');
            if (svgWrapper) svgWrapper.style.display = 'none';
            if (icon) icon.style.display = 'none';
        }

        /* ---- Replace with thin ← → arrows ---- */
        function addArrowChar(btn, arrowChar) {
            if (!btn) return;
            if (btn.querySelector('.gully-arrow-icon')) return;

            var span = document.createElement('span');
            span.className = 'gully-arrow-icon';
            span.textContent = arrowChar;
            span.style.cssText = [
                'font-size: 18px',
                'line-height: 1',
                'color: #777777',
                'font-weight: 300',
                'display: flex',
                'align-items: center',
                'justify-content: center',
                'font-family: system-ui, -apple-system, sans-serif'
            ].join(' !important; ') + ' !important;';
            btn.appendChild(span);
        }

        if (prevBtn) {
            styleArrowBtn(prevBtn);
            addArrowChar(prevBtn, '\u2190');
        }

        if (nextBtn) {
            styleArrowBtn(nextBtn);
            addArrowChar(nextBtn, '\u2192');
        }

        /* ---- Arrow visibility based on scroll position ---- */
        function updateArrows() {
            var scrollLeft = thumbList.scrollLeft;
            var maxScroll = thumbList.scrollWidth - thumbList.clientWidth;

            if (prevBtn) {
                if (scrollLeft <= 2) {
                    prevBtn.style.opacity = '0';
                    prevBtn.style.pointerEvents = 'none';
                } else {
                    prevBtn.style.opacity = '1';
                    prevBtn.style.pointerEvents = 'auto';
                }
            }

            if (nextBtn) {
                if (maxScroll <= 2 || scrollLeft >= maxScroll - 2) {
                    nextBtn.style.opacity = '0';
                    nextBtn.style.pointerEvents = 'none';
                } else {
                    nextBtn.style.opacity = '1';
                    nextBtn.style.pointerEvents = 'auto';
                }
            }
        }

        thumbList.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();

        // Re-apply after load in case Dawn resets
        window.addEventListener('load', function () {
            styleArrowBtn(prevBtn);
            styleArrowBtn(nextBtn);
            addArrowChar(prevBtn, '\u2190');
            addArrowChar(nextBtn, '\u2192');
            updateArrows();
        });
    }

    // Init with delay
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(initThumbnailStrip, 800);
        });
    } else {
        setTimeout(initThumbnailStrip, 800);
    }

    // Re-init on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initThumbnailStrip, 300);
    });
})();
